export enum OrderClientRelation {
    ATTORNEY_IN_FACT = 'AttorneyInFact',
    AUTHORISED = 'Authorised',
    TITULAR = 'Holder',
    TUTOR = 'Tutor',
}
